import { Collapse, Form } from 'antd';
import { useContext, useEffect, useReducer, useState } from 'react';
import * as THREE from 'three';
import Chip from '../../../../components/common/Chip/Chip';
import InputComponent from '../../../../components/common/InputComponent/InputComponent';
import SelectComponent from '../../../../components/common/SelectComponent/SelectComponent';
import RightMenuDesign from '../../../../components/house/RightMenuDesign/RightMenuDesign';
import { Icon } from '../../../../components/icon/icon';
import { DesignerPageContext } from '../../DesignerPage';
import './RightDoorWardrobeDesignMenu.scss';
import i18n from '../../../../languages/i18n';
import { useTranslation } from 'react-i18next';
import { DoorDirection, InsideType } from '../../../../constants/enum';
import { Switch } from 'antd';
const { Panel } = Collapse;

const openDirection = [
  {
    value: 'left',
    label: i18n.t('Left to right'),
  },
  {
    value: 'right',
    label: i18n.t('Right to left'),
  },
];

const horizontalTypeOptions = [
  {
    value: '1canh',
    label: i18n.t('1 door'),
  },
  {
    value: '2canh',
    label: i18n.t('2 door'),
  },
];

const RightDoorWardrobeDesignMenu = ({ open, form, className, title }) => {
  const { t } = useTranslation();
  const designerPageContext = useContext(DesignerPageContext);

  const [doorDirection, setDoorDirection] = useState();
  const [horizontalType, setHorizontalType] = useState();
  const [doorModel, setDoorModel] = useState();
  const [doorSize, setDoorSize] = useState(0);
  const [hasLock, setHasLock] = useState(false);

  useEffect(() => {
    if (designerPageContext?.meshClickRef?.current) {
      setDoorModel(designerPageContext.meshClickRef.current);
      setDoorDirection(
        designerPageContext.meshClickRef.current.userData?.handlePosition
          ?.current
      );
      setHorizontalType(
        designerPageContext.meshClickRef.current.userData?.horizontalType
      );
      setHasLock(designerPageContext.meshClickRef.current.userData?.lockUuid);

      const box = new THREE.Box3().setFromObject(
        designerPageContext.meshClickRef.current
      );
      const size = new THREE.Vector3();
      box.getSize(size);

      setDoorSize(size);
    }
  }, [designerPageContext]);

  const formForCurrentCabinet = [
    {
      key: '1',
      label: <span className="text-title-medium">{t('Door')}</span>,
      children: (
        <div className="flex flex-col gap-16 items-start self-stretch">
          <Form.Item
            label={<span className="text-label-medium">{t('Length')}</span>}
            className="self-stretch"
          >
            <InputComponent
              type={'number'}
              addonAfter={<span className="text-body-medium">mm</span>}
              placeholder={t('Enter')}
              disabled
              value={Math.round(Math.max(doorSize.x, doorSize.z) * 1000)}
            />
          </Form.Item>
          <Form.Item
            label={<span className="text-label-medium">{t('Height')}</span>}
            className="self-stretch"
          >
            <InputComponent
              type={'number'}
              addonAfter={<span className="text-body-medium">mm</span>}
              placeholder={t('Enter')}
              disabled
              value={Math.round(doorSize.y * 1000)}
            />
          </Form.Item>

          <Form.Item
            label={<span className="text-label-medium">{t('Thickness')}</span>}
            className="self-stretch"
          >
            <InputComponent
              type={'number'}
              addonAfter={<span className="text-body-medium">mm</span>}
              placeholder={t('Enter')}
              disabled
              value={Math.round(Math.min(doorSize.x, doorSize.z) * 1000)}
            />
          </Form.Item>
        </div>
      ),
    },
    ...(!doorModel?.userData?.drawerUuid
      ? [
          {
            key: '2',
            label: <span className="text-title-medium">{t('Edit Doors')}</span>,
            children: (
              <div className="flex flex-col gap-16 items-start self-stretch">
                <Form.Item
                  label={
                    <span className="text-label-medium">
                      {t('Open direction')}
                    </span>
                  }
                  className="self-stretch"
                >
                  <SelectComponent
                    options={openDirection}
                    style={{ flex: '1 0 0' }}
                    size={'default'}
                    // value={doorDirection}
                    //  disabled={
                    //   doorModel?.userData?.type === InsideType.DOOR_CLONE
                    // }
                    value={
                      doorModel?.userData?.doorDirection ===
                      DoorDirection.HORIZONTAL
                        ? 'Ngang'
                        : doorDirection
                    }
                    disabled={
                      doorModel?.userData?.type === InsideType.DOOR_CLONE ||
                      doorModel?.userData?.doorDirection ===
                        DoorDirection.HORIZONTAL
                    }
                    onChange={value => {
                      const foundModule =
                        designerPageContext.currentCabinet.getModuleByGroupUuid(
                          designerPageContext.selectedModel.uuid
                        );

                      designerPageContext.insideLoaderRef.current.toggleDoorDirection(
                        doorModel,
                        foundModule,
                        value
                      );

                      setDoorDirection(
                        doorModel?.userData?.handlePosition?.current
                      );
                      designerPageContext.setTick(t => t + 1);
                    }}
                  />
                </Form.Item>

                {doorModel?.userData?.doorDirection ===
                  DoorDirection.HORIZONTAL && (
                  <Form.Item
                    label={
                      <span className="text-label-medium">
                        {t('Horizontal type')}
                      </span>
                    }
                    className="self-stretch"
                  >
                    <SelectComponent
                      options={horizontalTypeOptions}
                      style={{ flex: '1 0 0' }}
                      size={'default'}
                      value={horizontalType}
                      disabled={
                        doorModel?.userData?.type === InsideType.DOOR_CLONE
                      }
                      onChange={async value => {
                        const foundModule =
                          designerPageContext.currentCabinet.getModuleByGroupUuid(
                            designerPageContext.selectedModel.uuid
                          );

                        const newDoor =
                          await designerPageContext.insideLoaderRef.current.toggleHorizontalType(
                            doorModel,
                            foundModule,
                            value
                          );

                        setHorizontalType(doorModel?.userData?.horizontalType);

                        if (newDoor) {
                          designerPageContext.meshClickRef.current = newDoor;
                          setDoorModel(newDoor);
                        } else {
                          designerPageContext.meshClickRef.current = null;
                          setDoorModel(null);
                        }

                        setTimeout(() => {
                          designerPageContext.sceneManager?.handleDrawBorder();
                          designerPageContext.sceneManager?.handleDrawBorderSelectedModule(
                            foundModule.group,
                            true
                          );
                        }, 0);

                        setTimeout(async () => {
                          await designerPageContext.sceneManager?.calculateTotalCost?.(
                            {}
                          );
                        }, 500);
                      }}
                    />
                  </Form.Item>
                )}
              </div>
            ),
          },
        ]
      : []),
    {
      key: '3',
      label: <span className="text-title-medium">{t('Lock')}</span>,
      children: (
        <div className="flex flex-col gap-16 items-start self-stretch">
          <Form.Item
            label={<span className="text-label-medium">{t('Lock')}</span>}
            className="self-stretch"
          >
            <Switch
              className="ml-auto"
              checked={hasLock ? true : false}
              onChange={value => {
                const foundModule =
                  designerPageContext.currentCabinet.getModuleByGroupUuid(
                    designerPageContext.selectedModel.uuid
                  );

                if (!foundModule) return;

                if (value) {
                  //Thêm ổ khóa
                  const addModelToCabinet = model => {
                    const data = {
                      _id: model.userData?.id,
                      glb: doorModel.userData.default_lock.model,
                      type: model.userData.type,
                      name: model.userData.name,
                      gltfUuid: model.uuid,
                      thumbnail_url: model.userData.thumbnail_url,
                      gltf: model,
                    };
                    model.userData.isInside = true;
                    model.userData.model =
                      doorModel.userData.default_lock.model;
                    foundModule.listInside.push(data);
                    foundModule.group.add(model);
                  };

                  const lockModel =
                    designerPageContext.insideLoaderRef.current.loadLockModel(
                      doorModel.userData.default_lock,
                      foundModule,
                      doorModel,
                      addModelToCabinet
                    );

                  doorModel.userData.lockUuid = lockModel.uuid;
                  setHasLock(true);
                } else {
                  //Xóa ổ khóa
                  if (doorModel.userData.lockUuid) {
                    const oldLock =
                      designerPageContext.insideLoaderRef.current.findMeshByUuid(
                        foundModule.group,
                        doorModel.userData.lockUuid
                      );

                    designerPageContext.insideLoaderRef.current.removeInside(
                      oldLock,
                      foundModule
                    );
                  }

                  doorModel.userData.lockUuid = null;
                  setHasLock(false);
                }

                setTimeout(async () => {
                  await designerPageContext.sceneManager?.calculateTotalCost?.(
                    {}
                  );
                }, 300);
              }}
            />
          </Form.Item>
        </div>
      ),
    },
  ];

  return (
    <RightMenuDesign
      open={open}
      classNames={{
        root: 'top-16 ' + className,
        content: '!p-0 gap-0',
      }}
      header={
        <span className="text-title-large text-nowrap">
          {title ?? 'Tùy chỉnh'}
        </span>
      }
      content={
        <>
          <Form
            form={form}
            labelAlign="left"
            labelWrap
            labelCol={{ style: { minWidth: '101px' } }}
            colon={false}
            layout="horizontal"
            validateTrigger={'onChange'}
            className="left-cabinet-design-menu-body flex flex-col items-start overflow-hidden p-8 gap-8 grow self-stretch"
          >
            <Collapse
              expandIcon={({ isActive }) => (
                <span className="w-16 h-16 flex">
                  {isActive ? <Icon.ICExpandMore /> : <Icon.ICExpandLess />}
                </span>
              )}
              defaultActiveKey={['1', '2', '3']}
              onChange={() => {}}
              className="self-stretch overflow-auto"
              items={formForCurrentCabinet.map(item => ({
                ...item,
                onKeyDown: e => {
                  e.stopPropagation();
                },
              }))}
            />
          </Form>
        </>
      }
    />
  );
};

export default RightDoorWardrobeDesignMenu;
